export default __webpack_public_path__ + "static/media/pfpjacob.6523cfb5.webp";